import * as actionTypes from '../actionTypes';
import { OutdoorConditionsPayload } from 'views/dashboard/outdoor/types';
import {
    FetchOutdoorConditionsFailure,
    FetchOutdoorConditionsFailurePayload,
    FetchOutdoorConditionsRequest,
    FetchOutdoorConditionsSuccess,
} from 'redux/types/outdoorConditionsActionModel';

export const fetchOutdoorConditionsRequest = (): FetchOutdoorConditionsRequest => ({
    type: actionTypes.FETCH_OUTDOOR_CONDITIONS_REQUEST,
});

export const fetchOutdoorConditionsSuccess = (
    payload: OutdoorConditionsPayload,
): FetchOutdoorConditionsSuccess => ({
    type: actionTypes.FETCH_OUTDOOR_CONDITIONS_SUCCESS,
    payload,
});

export const fetchOutdoorConditionsFailure = (
    payload: FetchOutdoorConditionsFailurePayload,
): FetchOutdoorConditionsFailure => ({
    type: actionTypes.FETCH_OUTDOOR_CONDITIONS_FAILURE,
    payload,
});
